import { Observable } from "rxjs";
import { cacheWithExpiration } from '../operators/cache-with-expiration.operator';

export class CacheObservable<TResult> {
  private cacheItems = new Map<string, Observable<TResult>>;

  constructor(private readonly expirationsMs: number) {
  }

  getCachedItems(isServer: boolean, cacheKey: string, getData: () => Observable<TResult>): Observable<TResult> {
    if (isServer) {
      return getData();
    }

    let observable: Observable<TResult>;

    if (!this.cacheItems.has(cacheKey)) {
      observable = getData().pipe(cacheWithExpiration(this.expirationsMs));

      this.cacheItems.set(cacheKey, observable);
    }
    else {
      observable = this.cacheItems.get(cacheKey)!;
    }

    return observable;
  }
}
